var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 20.0003C4.16602 12.5364 4.16602 8.80448 6.48475 6.48573C8.8035 4.16699 12.5354 4.16699 19.9993 4.16699C27.4632 4.16699 31.1952 4.16699 33.514 6.48573C35.8327 8.80448 35.8327 12.5364 35.8327 20.0003C35.8327 27.4642 35.8327 31.1962 33.514 33.515C31.1952 35.8337 27.4632 35.8337 19.9993 35.8337C12.5354 35.8337 8.8035 35.8337 6.48475 33.515C4.16602 31.1962 4.16602 27.4642 4.16602 20.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 20C27.5 24.1422 24.1422 27.5 20 27.5C15.8579 27.5 12.5 24.1422 12.5 20C12.5 15.8579 15.8579 12.5 20 12.5C24.1422 12.5 27.5 15.8579 27.5 20Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1791 10.833H29.1641",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.49ff65560148104c4d38b9960f108aa9.svg";
export { ForwardRef as ReactComponent };